import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoatOwnerAvailabilityComponent } from './boat-owner-availability.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { VesselAvailabilityDialogModule } from './dialogs/vessel-availability-dialog.module';
import { VesselAvailabilityPreferencesDAO } from '../../../../../../../../core/services/dao/vesselAvailabilityPreferencesDAO';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingModule } from '../../../../../../../shared/loading/loading.module';
import { ProductOfferingFormModule } from './product-offering-form/product-offering-form.module';
import { ProductOfferingFormComponent } from './product-offering-form/product-offering-form.component';
import { ActiveProductOfferingsModule } from '../../../../../../../shared/pipes/active-product-offerings/active-product-offerings.module';

@NgModule({
  declarations: [BoatOwnerAvailabilityComponent],
  exports: [BoatOwnerAvailabilityComponent],
  entryComponents: [ProductOfferingFormComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatRadioModule,
    FormsModule,
    VesselAvailabilityDialogModule,
    LoadingModule,
    MatProgressSpinnerModule,
    ProductOfferingFormModule,
    MatIconModule,
    ActiveProductOfferingsModule,
  ],
  providers: [VesselAvailabilityPreferencesDAO],
})
export class BoatOwnerAvailabilityModule {}
